/**
 * Map a host client-type string onto our neutral {@link ClientType} union.
 *
 * Kept as a free function with no SDK import so the rule it encodes can be
 * unit-tested directly — it decides whether the app shows anyone a price.
 *
 * Only android / ios / ipados are `'mobile'`: those are the Teams mobile apps
 * that Microsoft's marketplace certification policy 114048 governs, which
 * forbids upsell, purchase, and payment-related references. Room and phone
 * devices (teamsRoomsAndroid, teamsPhones, teamsDisplays) are Android-based
 * but are not the mobile app, so they fall through.
 *
 * Anything unrecognised maps to `'unknown'`, NEVER `'mobile'`. That direction
 * is deliberate: treating an unknown client as mobile would hide Subscribe
 * from a paying desktop customer, which is a worse failure than the policy
 * risk it avoids. Inside real Teams — the only place the policy applies — the
 * host always populates this field; it is empty only in browser dev, where
 * there is no policy to breach.
 */
export function mapClientType(clientType) {
    switch (clientType) {
        case 'android':
        case 'ios':
        case 'ipados':
            return 'mobile';
        case 'desktop':
        case 'macos':
            return 'desktop';
        case 'web':
            return 'web';
        default:
            return 'unknown';
    }
}
//# sourceMappingURL=client-type.js.map